import {createReducer, on} from '@ngrx/store';
import {
  clearDeleteManyMultiviewsState,
  deleteManyMultiviews,
  deleteManyMultiviewsFailure,
  deleteManyMultiviewsSuccess
} from './multiview.delete-many.actions';
import {Multiview} from '../../../services/api/multiviews/multiview-viewer.model';


export interface State {
  record: Multiview[] | null;
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false
};


export const deleteManyMultiviewsReducer = createReducer(
  initialState,

  on(deleteManyMultiviews, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: true
  })),
  on(deleteManyMultiviewsSuccess, (): State => ({
    record: null,
    error: null,
    loaded: true,
    loading: false
  })),
  on(deleteManyMultiviewsFailure, (_state: State, action): State => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(clearDeleteManyMultiviewsState, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: false
  }))
);

